import React from 'react';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import style from '../common.module.less';

export const FormIsRadioOptions = (criterionStateMethods, criterionArgumentOptions) => {
  const { getCriterionArgument, updateCriterionArgument } = criterionStateMethods;
  const { id } = getCriterionArgument() || {};
  const selectedCriterionId = id;

  return (
    <div className={style['form-criteria-section']}>
      <RadioCheckList>
        {criterionArgumentOptions.map((option) => {
          const optionDisplayName = option.displayName;
          const optionId = option.id;
          return (
            <RadioCheckListItem
              key={optionId}
              isChecked={optionId === selectedCriterionId}
              onChecked={() => updateCriterionArgument(option)}
            >
              {optionDisplayName}
            </RadioCheckListItem>
          );
        })}
      </RadioCheckList>
    </div>
  );
};
